<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Yritykset</h2>
            <p>Tässä näet yritykset</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{companies.length}}</h2>
                                <p class="white-text">Yritystä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{pub}}</h2>
                                <p class="white-text">Julkiset</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{priv}}</h2>
                                <p class="white-text">Yksityiset</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <button class="btn btn-formed-main-black" routerLink="/admins/admin/add-company">Lisää yritys</button>
        <table class="table table-striped">
            <thead>
                <tr>
                    <td>Rekisteröity</td>
                    <td>Nimi</td>
                    <td>ID</td>
                    <td>Tiedot</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of companies">
                    <td>{{data.createdDate}}</td>
                    <td>{{data.businessName}}</td>
                    <td>{{data.businessID}}</td>
                    <td><button routerLink="/admins/admin/companies/company/company-details/{{data.businessID}}" class="btn btn-formed-main-black">Tiedot</button></td>

                </tr>
            </tbody>
        </table>
        </div>

        <div class="col-1"></div>
  </div>

  </div>

    </div>